import React, { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import NoImage from "../../../Assets/images/no-image.png";
import ImageUploadWithCrop from "../../../CoreComponents/ImageUploadWithCrop";
import EditBottomComponent from "../../../CoreComponents/EditBottomComponent";
import { ManageVariantImage } from "../Logics";
import {
  showMessage,
  handleImageError,
} from "../../../Functionalities/Functions";
import { PICTURE_SHAPES } from "../../../Functionalities/pictureShapes";

function ProductImageGallery({ data, setData, setEdit }) {
  const [imageData, setImageData] = useState([]);
  const [compression, setCompression] = useState(true);

  return (
    <div className="col-xl-3 col-lg-6 col-md-6 col-xxl-5">
      {/* Tab panes */}
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane fade show active" id="first">
          {data.images.length ? (
            <img
              className="img-fluid"
              src={data.displayImage}
              alt=""
              onError={handleImageError}
            />
          ) : (
            <img className="img-fluid" src={NoImage} alt="" />
          )}
        </div>
      </div>
      <div className="tab-slide-content new-arrival-product mb-4 mb-xl-0">
        {/* Nav tabs */}
        <ul className="nav slide-item-list mt-3" role="tablist">
          {data.images.length > 0 &&
            data.images.map((item, index) => {
              return (
                <li role="presentation" key={item.id || index}>
                  <i
                    className="fa fa-trash-o text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      confirmAlert({
                        customUI: ({ onClose }) => {
                          return (
                            <div
                              className="custom-ui"
                              style={{
                                borderRadius: 8,
                                border: "solid",
                                padding: 70,
                                borderWidth: 0.5,
                              }}
                            >
                              <h1>Are you sure?</h1>
                              <p>You want to delete ?</p>
                              <button
                                onClick={onClose}
                                className="btn btn-primary"
                                style={{ marginRight: 10 }}
                              >
                                Cancel
                              </button>
                              <button
                                onClick={() => {
                                  ManageVariantImage(
                                    "",
                                    "patch",
                                    {
                                      item_id: data.id,
                                      keyword: "remove_images",
                                      image_ids: item.id,
                                    },
                                    ""
                                  )
                                    .then((res) => {
                                      if (res.data.Status === true) {
                                        showMessage(
                                          "Delete success",
                                          "success",
                                          "Success!",
                                          "top",
                                          "top-right"
                                        );
                                        window.location.reload();
                                      } else {
                                        showMessage(
                                          res.data.Error,
                                          "danger",
                                          "Failed!",
                                          "top",
                                          "top-right"
                                        );
                                      }
                                    })
                                    .catch((err) => {
                                      showMessage(
                                        "Something went wrong",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right"
                                      );
                                    });
                                }}
                                className="btn btn-primary"
                              >
                                Delete
                              </button>
                            </div>
                          );
                        },
                      });
                    }}
                  ></i>
                  <a
                    href="#for"
                    role="tab"
                    data-toggle="tab"
                    onClick={() =>
                      setData({
                        ...data,
                        displayImage: item.image,
                      })
                    }
                  >
                    <img
                      className="img-fluid"
                      src={item.image}
                      alt=""
                      width={50}
                      onError={handleImageError}
                    />
                  </a>
                </li>
              );
            })}
        </ul>
      </div>

      {data.images.length <= 0 && (
        <p className="mt-3">
          <a data-toggle="modal" data-target="#addImageModal" href="#">
            {" "}
            <i className="fa fa-plus-circle text-success fa-2x"></i>{" "}
          </a>{" "}
          Add Images
          <div className="modal fade" id="addImageModal">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Images</h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                  >
                    {" "}
                    <span>×</span>{" "}
                  </button>
                </div>
                <div className="modal-body">
                  <form className="comment-form">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="text-black font-w600">
                            Choose Images{" "}
                            <span className="required"></span>
                            <br />
                            <b>Compress image </b>
                            <input
                              type="checkbox"
                              checked={compression}
                              onChange={(e) => {
                                setCompression(e.target.checked);
                                setImageData([]);
                              }}
                            />
                          </label>
                          <div className="col-sm-12">
                            <ImageUploadWithCrop
                              value={imageData}
                              onChange={(file) => setImageData(file)}
                              {...PICTURE_SHAPES.product}
                              compress={compression}
                            />
                          </div>
                        </div>
                      </div>
                      <EditBottomComponent
                        cancelButton={(e) => {
                          e.preventDefault();
                          setEdit(false);
                        }}
                        saveButton={(e) => {
                          e.preventDefault();
                          if (data.name === "") {
                            showMessage(
                              "Name cannot be empty",
                              "danger",
                              "Validation error",
                              "top",
                              "top-right",
                              0
                            );
                            return;
                          }
                          let result = ManageVariantImage(
                            e,
                            "patch",
                            {
                              item_id: data.id,
                              keyword: "add_images",
                              images: imageData,
                            },
                            ""
                          );
                          result
                            .then((res) => {
                              if (res.data.Status === true) {
                                window.location.reload();
                              } else {
                                showMessage(
                                  res.data.Error,
                                  "danger",
                                  "Failed",
                                  "top",
                                  "top-right",
                                  0
                                );
                              }
                            })
                            .catch((err) => err);
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </p>
      )}
    </div>
  );
}

export default ProductImageGallery;
